module.exports = __webpack_public_path__ + "media/homeVideoIphone.e079a841.mp4";